module.exports = __webpack_public_path__ + "media/basic-details/all_hands@1x-c4f81e48.png";